<template>
    <div class="position-relative mb-11">
        <gofix-card title="Infringements" class="mb-0" classHeader="mb-2" classContent="mb-0" :class="{'run-loading': Loading}">
            <template slot="gofixCard:right_header">
                <gofix-button v-if="isAccess" label=" " class="mr-30" @click="storageItem(null, 'edit')" noBorder>
                    <template slot="gofix:button:beforeLabel">
                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                            <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                            <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                        </svg>
                    </template>
                </gofix-button>
            </template>
            <b-row no-gutters class="mb-15">
                <template v-for="(item, index) in WorkFindings">
                    <b-col md="6" class="pr-15  mb-10" :key='index'>
                        <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                            <b-row>
                                <b-col md="10" class="mb-15">
                                    <gofix-text-field label="Observations / Non-Compliances" oneline>
                                        <span v-html="item.observations_non_compliances"></span>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="2" class="mb-15 text-right">
                                    <span v-if="isAccess" class="editBox position-static cursor-pointer mr-12" @click="storageItem(item, 'edit')">
                                        <img src="img/iconPencil.png" alt  width="18" height="18"/>
                                    </span>
                                    <span v-if="isAccess" class="editBox position-static cursor-pointer" @click="storageItem(item, 'delete')">
                                        <img src="img/deleteIcon.png" alt  width="20" height="20"/>
                                    </span>
                                </b-col>
                                <b-col md="6" class="mb-15">
                                    <gofix-text-field label="Risk Level" oneline>
                                        <span v-html="item.risk_level"></span>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="6" class="mb-15">
                                    <gofix-text-field label="Responsible Person" oneline>
                                        <span>{{ item.responsible_person && item.responsible_person.name ? item.responsible_person.name : null }}</span>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="12" class="mb-15">
                                    <gofix-text-field classLabel="width-198" label="Additional Information" oneline>
                                        <span v-html="item.description ? item.description.replaceAll('\n', '<br>') : ''"></span>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="12" class="mb-15">
                                    <gofix-text-field classLabel="width-198" label="Corrective Action" oneline>
                                        <span v-html="item.corrective_action ? item.corrective_action.replaceAll('\n', '<br>') : ''"></span>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="12" class="mb-15">
                                    <gofix-text-field classLabel="width-198" label="Preventive Action" oneline>
                                        <span v-html="item.preventive_action ? item.preventive_action.replaceAll('\n', '<br>') : ''"></span>
                                    </gofix-text-field>
                                </b-col>
                                
                                <b-col md="12" class="photosThumb mt-0">
                                    <gofix-text-field label="photos" oneline>
                                        <template v-if="item.attachments">
                                            <viewer-image :images="item.attachments" classViewer='d-flex align-items-center'>
                                                <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                    <ul class="list-thumb checklist">
                                                        <template v-for="(item, key) in images">
                                                            <li v-if="images.length <= limitImage || key <= ( images.length - ( limitImage + 1) )" :class="{'d-none': key > (limitImage-1)}" v-bind:key="key">
                                                                <img :alt="item.image_file_name" :key="item.url.original" v-auth-image="item.url.original"  src="img/loading.gif">
                                                            </li>
                                                        </template>
                                                    </ul>
                                                    <template v-if="images.length > limitImage">
                                                        <div class="attachmentsColumn cursor-pointer pl-0">
                                                            <div class="item-content bg-transparent pd-0">
                                                                <img class="image-viewer" v-auth-image="images[images.length-1].url.original" src="img/loading.gif">
                                                                <span class="checklist-photo-custom" v-if="images.length > limitImage">+{{ images.length - limitImage }}</span>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </viewer-image>
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                            <ActionTaken :safety_work_finding_id="item.id" :action_taken="item.action_taken" @reloadData="getItems"></ActionTaken>
                        </gofix-card>
                    </b-col>
                </template>
            </b-row>
            <b-modal :no-close-on-backdrop="true" size="md" id="modal-Create" title="Infringements" hide-footer :centered="true" ref="modal-edit-work-finding" v-model="modal.edit.open">
                <b-form class="pb-10">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Observations / Non-Compliances"
                                vLabel="reference_value_text"
                                :reduce="option => option.reference_value_text"
                                :options="options.observations_non_compliances"
                                v-model="work_finding.observations_non_compliances"
                                >
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Risk Level"
                                vLabel="reference_value_text"
                                :reduce="option => option.reference_value_text"
                                :options="options.risk_levels"
                                v-model="work_finding.risk_level"
                                >
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-dropdown
                                label="Responsible Person"
                                vLabel="user_name"
                                @search="searchUser"
                                :filterable="false"
                                :required="true"
                                :show-icon-required="true"
                                v-model="work_finding.responsible_person"
                                :options="options.suppliers">
                                <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                    {{option.user_name}} - {{option.user_email}}
                                </template>
                                <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                    {{option.user_name}} - {{option.user_email}}
                                </template>
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input-textarea label="Additional Information" :rows="5" v-model="work_finding.description"></gofix-form-input-textarea>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-textarea label="Corrective Action" :rows="5" v-model="work_finding.corrective_action"></gofix-form-input-textarea>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-textarea label="Preventive Action" :rows="5" v-model="work_finding.preventive_action"></gofix-form-input-textarea>
                        </b-col>
                    </b-row>
                    <b-form-group label="photos" class="photosThumb clear-both">
                        <ul class="list-thumb">
                            <li v-for="(item,key) in work_finding.attachments" v-bind:key="key">
                                <img v-auth-image="item.url.thumb" src="img/loading.gif" alt />
                                <span class="delete" @click="deleteImgWorkFinding(item)">
                                    <img src="img/close.png" alt />
                                </span>
                            </li>
                        </ul>
                        <div class="upload-btn-wrapper">
                            <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgWorkFinding" :plain="true" :multiple="true"></b-form-file>
                            <gofix-button class="m-3" label="add photo" outline></gofix-button>
                        </div>
                    </b-form-group>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button v-if="work_finding.id" :disabled="work_finding.issue_register_id ? true : false" @click="deleteItem" label="DELETE" class="mr-3 pull-left" noBorder></gofix-button>
                    <!-- <gofix-button label=" "  @click="showPriority" :disabled="work_finding.issue_register_id ? true : false" :loading="isActionIssue" noBorder>
                        <template slot="gofix:button:beforeLabel">SAVE &amp; RAISE<br/>ISSUE</template>
                    </gofix-button> -->
                    <gofix-button label="SAVE" @click="saveItem()" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.delete.open">
                <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
                <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="modal.delete.open = false">No</b-button>
                    <b-button class="custom-btn" :disabled="modal.delete.loading" @click="deleteItem"> <b-spinner v-if="modal.delete.loading" small type="grow"></b-spinner> Yes</b-button>
                </b-button-group>
            </b-modal>
            <!-- <priority :loading="modal.sla.loading" :service-category-id="modal.sla.service_category_id" @raise-issue="raiseIssue" v-model="modal.sla.open"></priority> -->
        </gofix-card>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    // const Priority = () => import('./modal_priority.vue')
    const ActionTaken = () => import('./modal_action_taken.vue')
    import moment from 'moment';
    export default {
        name: 'safe-inspection-checklist-detail-infringement',
        components: {
            ViewerImage,
            ActionTaken
            // Priority
        },
        data() {
            return{
                isAction: false,
                limitImage: 2,
                imgWorkFinding: null,
                imgWorkFindingAction: {
                    photos: [],
                    delete: [],
                },
                work_finding_del_ids: [],
                work_finding: {},
                modal: {
                    edit: {
                        open: false,
                        loading: false
                    },
                    delete: {
                        open: false,
                        loading: false
                    },
                },
                options: {
                    observations_non_compliances: [],
                    risk_levels: [],
                    suppliers: []
                },
                timer: {
                    user: null,
                    edit: null,
                    delete: null
                }
            }
        },
        computed: {
            ...mapGetters({
                Item: 'SafetyAppController/safetyJob',
                JobWorkFinding: "SafetyAppController/workFindings",
                Loading: "SafetyAppController/wfLoading",
            }),
            WorkFindings: function() {
                return this.JobWorkFinding.items;
            },
            isAccess() {
                if(!this.$checkRole(this.$accessModule.safety_inspection_checklist, 'update') || (this.Item && this.Item.status != 'New')) return false;
                return true;
            },
        },
        mounted() {
            this.$nextTick(function () {
                window.addEventListener('resize', this.handleResize);
            })
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            this.handleResize();
            this.getRiskLevel();
            this.getObservations();
            if(this.Item && this.Item.id)
                this.getItems();
        },
        watch: {
            imgWorkFinding(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };

                        this.imgWorkFindingAction.photos.push(file);
                        this.work_finding.attachments.push(data);
                    });
                }
            }
        },
        methods: {
            handleResize() {
                this.limitImage = 2
                if (window.innerWidth < 1920) {
                    this.limitImage = 1
                }
            },
            /* --- Work Finding --- */
            getItems() {
                this.$store.dispatch("SafetyAppController/getWorkFindings", {
                    isCMS: false,
                    filter: {
                        safety_job_id: this.Item.id
                    },
                    limit: -1
                })
            },
            storageItem(item, action = null) {
                this.isAction             = false;
                this.modal.edit.loading   = false;
                this.modal.delete.loading = false;

                this.work_finding_del_ids = [];
                this.imgWorkFindingAction.photos = [];
                
                if(item) {
                    this.work_finding = JSON.parse(JSON.stringify(item));
                    if(this.work_finding.responsible_person) {
                        this.work_finding.responsible_person = {
                            id: this.work_finding.responsible_person.id,
                            user_id: this.work_finding.responsible_person.id,
                            user_name: this.work_finding.responsible_person.name,
                            user_email: this.work_finding.responsible_person.email
                        }
                    }
                } else {
                    this.work_finding = {
                        safety_job_id: this.Item.id,
                        description:  null,
                        observations_non_compliances:  null,
                        risk_level:  null,
                        corrective_action: null,
                        preventive_action: null,
                        responsible_person: null,
                        attachments: [],
                    }
                }

                if(action == 'edit'){
                    this.getUsers()
                    this.modal.edit.open = true;
                }

                if(action == 'delete') {
                    this.modal.delete.open = true;
                }
            },
            saveItem() {
                if (this.timer.edit) {
                    clearTimeout(this.timer.edit);
                    this.timer.edit = null;
                }
                this.timer.edit = setTimeout(async () => {
                    if(this.isAction) return;
                    this.isAction = true;

                    if(this.work_finding_del_ids.length > 0) {
                        await this.$store.dispatch("SafetyAppController/deleteAttachments", { ids : this.work_finding_del_ids } )
                        .then(result => {
                            this.work_finding_del_ids = [];
                        })
                    }
                    let params = JSON.parse(JSON.stringify(this.work_finding));
                    if(this.work_finding.responsible_person && this.work_finding.responsible_person.id) {
                        params.responsible_person_by_id = this.work_finding.responsible_person.user_id
                    }
                    await this.$store
                        .dispatch("SafetyAppController/saveWorkFindingItem", {
                            data:   params,
                            photos: this.imgWorkFindingAction.photos
                        })
                        .then((result) => {

                            this.imgWorkFindingAction = {
                                photos: [],
                                delete: [],
                            };

                            this.getItems();
                            this.modal.edit.open    = false;
                            this.modal.edit.loading = false;
                            if(this.work_finding.id) this.$emit('reloadItem');
                            this.$alertNotification(this.$notificationV2(this.work_finding.id ? "editing" : 'adding', "safe_inspection_checklist_work_finding"));
                        })
                        .catch(error => {
                            this.modal.edit.loading = false;
                            this.isAction = false;
                            console.log(error);
                        });
                }, 100)
            },
            deleteItem() {
                if(!this.work_finding.id) return;
                if (this.timer.delete) {
                    clearTimeout(this.timer.delete);
                    this.timer.delete = null;
                }
                this.timer.delete = setTimeout(() => {
                    this.modal.delete.loading = true;
                    this.$store.dispatch('SafetyAppController/deleteWorkFindingItem', {
                        ids: [this.work_finding.id]
                    })
                    .then(response => {
                        this.modal.delete.open    = false;
                        this.modal.delete.loading = false;
                        this.modal.edit.open      = false;
                        this.getItems();
                        this.$alertNotification(this.$notificationV2('deleting', 'safe_inspection_checklist_work_finding'));
                    })
                    .catch(error => {
                        this.modal.delete.loading = false;
                        console.log(error);
                    });
                }, 100)
            },
            deleteImgWorkFinding(img) {
                if (img.moment) {
                    this.work_finding.attachments = this.work_finding.attachments.filter(
                        (item) => item.moment != img.moment
                    );
                    this.imgWorkFindingAction.photos = this.imgWorkFindingAction.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.work_finding_del_ids.push(img.id);
                    this.work_finding.attachments = this.work_finding.attachments.filter(
                        (item) => item.id != img.id
                    );
                }
            },
            async getUsers(search = null){
                let filter = {
                    user_name:{type:"text",value:search,function:"ilike",with:[]},
                    user_email:{type:"text",value:search,function:"ilike",with:[]},
                    user_type:{type:"text",value:'Supplier',function:"ilike",with:[]},
                    role_name:{type:"text",value:"Contractor Supervisor",function:"ilike",with:[]},
                    contract_id:{type:"number",value:this.Item.project_id,function:"=",with:[]},
                };
                let request = {
                    limit: 100,
                    page: 1,
                    isCMS:1,
                    sortColumn:'user_id',
                    sortDirection:'ASC',
                    filter: filter,
                    useDatabaseView:true,
                    staff: true
                };
                this.$store.dispatch("UserDutyController/getItems", request)
                    .then(result=>{
                        this.options.suppliers = result.items;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            searchUser(search, loading) {
                loading(true);
                if (this.timer.user) {
                    clearTimeout(this.timer.user);
                    this.timer.user = null;
                }
                this.timer.user = setTimeout(() => {
                    this.getUsers(100, search);
                    loading(false);
                }, 500);
            },
            getRiskLevel(){
                this.getReference({reference_type: "Safety Risk Level"}, 'risk_levels');
            },
            getObservations(){
                this.getReference({reference_type: "Safety Categories Of Hazard"}, 'observations_non_compliances');
            },
            getReference(filter = {}, option){
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.options[option] = response.items;
                })
            }
        }
    }
</script>
